import SingleMediaUploader from './SingleMediaUploader.vue'
import SingleFileInput from './SingleFileInput.vue'
import FileUploader from './FileUploader.vue'
import FileUploaderTable from './FileUploaderTable.vue'
import Preloader from './Preloader.vue'
import Checkbox from './Checkbox.vue'
import RichTextarea from './RichTextarea.vue'
import AceTextarea from './AceTextArea.vue'
import CodeTextarea from './CodeTextArea.vue'
import TrumbowygTextarea from './TrumbowygTextArea.vue'

import SimpleCard from './SimpleCard.vue'
import Datatable from './Datatable.vue'
import SimpleTable from './SimpleTable.vue'
import Mailbox from './Mailbox.vue'
import Sortable from './Sortable.vue'
import Flash from './Flash.vue'

import ToggleOptionElement from './DatatableElements/ToggleOptionElement.vue'
import DeleteElement from './DatatableElements/DeleteElement.vue'
import ColorElement from './DatatableElements/ColorElement.vue'

import StatusComponent from './StatusComponent.vue'

import { Line } from 'vue-chartjs'

export default {
  SingleFileInput,
  SingleMediaUploader,
  FileUploader,
  FileUploaderTable,
  Preloader,
  Datatable,
  SimpleTable,

  Mailbox,
  SimpleCard,
  Checkbox,
  RichTextarea,
  AceTextarea,
  CodeTextarea,
  TrumbowygTextarea,
  Sortable,
  Flash,

  ToggleOptionElement,
  DeleteElement,
  ColorElement,

  Line,
  StatusComponent
}



// WEBPACK FOOTER //
// ./src/components/ui/index.js